module.exports = __webpack_public_path__ + "media/images/service/c_11-c900e8496fab59b1fd27aaa59ffde977.png";